module.exports = __webpack_public_path__ + "img/qx_icon8.cc298ee0.png";